import { GenericDataType } from "src/modules/enaio/shared/GenericDataType";

export class AdvancedFormTableColumn
{
    id = "";
    title = "";
    dataType: GenericDataType;
}